const addExperimentToDatadogContext = (key: string, payload: any) => {
  import(/* webpackChunkName: "datadog" */ '@datadog/browser-rum').then(async ({ datadogRum }) => {
    datadogRum.addRumGlobalContext(key, payload);
  });
};

export default addExperimentToDatadogContext;
